// components/SignIn.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthWrapper from '../AuthWrapper';

const SignIn = () => {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validateForm = () => {
    if (!identifier.trim()) {
      setError('Username or email is required');
      return false;
    }
    if (!password.trim()) {
      setError('Password is required');
      return false;
    }
    setError('');
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!validateForm()) return;

    setLoading(true);

    try {
      // Replace with your actual API endpoint
      const response = await fetch('http://localhost:5000/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ identifier, password }),
      });

      const data = await response.json();

      if (response.ok) {
        // Store token and user data
        localStorage.setItem('token', data.token);
        if (data.user) {
          localStorage.setItem('userName', data.user.name || '');
          localStorage.setItem('userRole', data.user.role || 'user');
        }
        // Redirect to home page
        navigate('/');
        window.location.reload();
      } else {
        setError(data.message || 'Login failed. Please try again.');
      }
    } catch (err) {
      setError('Network error. Please check your connection.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthWrapper>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 20 }}>
          <label style={{
            display: 'block',
            fontSize: 13,
            fontWeight: 600,
            color: '#374151',
            marginBottom: 6,
          }}>
            Username or Email
          </label>
          <input
            type="text"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            placeholder="Enter your username or email"
            style={{
              width: '100%',
              padding: '12px 14px',
              border: '1.5px solid #D1D5DB',
              borderRadius: 8,
              fontSize: 14,
              transition: 'border-color 0.2s',
              outline: 'none',
            }}
            onFocus={(e) => e.target.style.borderColor = '#1D9E75'}
            onBlur={(e) => e.target.style.borderColor = '#D1D5DB'}
          />
        </div>

        <div style={{ marginBottom: 24 }}>
          <label style={{
            display: 'block',
            fontSize: 13,
            fontWeight: 600,
            color: '#374151',
            marginBottom: 6,
          }}>
            Password
          </label>
          <div style={{ position: 'relative' }}>
            <input
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              style={{
                width: '100%',
                padding: '12px 14px',
                paddingRight: '48px',
                border: '1.5px solid #D1D5DB',
                borderRadius: 8,
                fontSize: 14,
                transition: 'border-color 0.2s',
                outline: 'none',
              }}
              onFocus={(e) => e.target.style.borderColor = '#1D9E75'}
              onBlur={(e) => e.target.style.borderColor = '#D1D5DB'}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: 'absolute',
                right: 12,
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: '#6B7280',
                fontSize: 18,
                padding: 4,
              }}
            >
              <i className={`ti ${showPassword ? 'ti-eye-off' : 'ti-eye'}`} aria-hidden="true" />
            </button>
          </div>
        </div>

        {error && (
          <div style={{
            padding: '12px 14px',
            background: '#FEE2E2',
            borderRadius: 8,
            marginBottom: 16,
            color: '#DC2626',
            fontSize: 13,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
          }}>
            <i className="ti ti-alert-circle" aria-hidden="true" />
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            padding: '12px',
            background: '#1D9E75',
            color: '#ffffff',
            border: 'none',
            borderRadius: 8,
            fontSize: 15,
            fontWeight: 600,
            cursor: loading ? 'not-allowed' : 'pointer',
            transition: 'all 0.2s',
            opacity: loading ? 0.7 : 1,
          }}
          onMouseEnter={(e) => {
            if (!loading) e.currentTarget.style.background = '#167A5A';
          }}
          onMouseLeave={(e) => {
            if (!loading) e.currentTarget.style.background = '#1D9E75';
          }}
        >
          {loading ? (
            <span>
              <i className="ti ti-loader" style={{ animation: 'spin 1s linear infinite', marginRight: 8 }} aria-hidden="true" />
              Signing in...
            </span>
          ) : (
            'Sign In'
          )}
        </button>
      </form>
    </AuthWrapper>
  );
};

export default SignIn;